import {
  type BuildDetailsFieldsParams,
  checkboxField,
  field,
  leftColumn,
  rightColumn,
  selectField,
  typedField,
  withLayout,
} from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildPaymentDetailsFields({ opportunity }: BuildDetailsFieldsParams): Array<DetailField> {
  const contract = opportunity?.contract;

  return [
    selectField(
      'Payment Method',
      contract?.payment_method__c,
      ['VCC(Citibank)', 'Bank Transfer', 'Credit Card'],
      undefined,
      leftColumn,
    ),
    typedField('Admin Fee (%)', undefined, 'number', undefined, leftColumn),
    withLayout(
      field(
        'Payment Milestone',
        contract?.payment_milestone__c,
        'Use this picklist field to assign the payment breakdown to be used.',
      ),
      leftColumn,
    ),
    selectField('Product Segment', undefined, ['Escapes', 'Tours', 'Cruises'], undefined, leftColumn),
    typedField('Chain Margin Contribution (%)', undefined, 'number', undefined, leftColumn),
    withLayout(
      field(
        'LE Marketing Terms',
        undefined,
        'Use this picklist field to assign the marketing term to be merged into the contract.',
      ),
      leftColumn,
    ),
    checkboxField('PCM Margin Deduction', undefined, undefined, { ...leftColumn, compact: true }),
    checkboxField('Deal with Special Payment Terms', undefined, undefined, { ...leftColumn, compact: true }),
    selectField(
      'LE Contracts Geo',
      undefined,
      ['International', 'Australia', 'USA', 'Europe', 'Asia'],
      'This picklist field is used to determine how tax impacts the margin calculation and which marketing terms are to be merged into the contract.',
      rightColumn,
    ),
    withLayout(field('Payment Term Description', undefined, undefined, true), rightColumn),
    withLayout(field('Special Payment Terms Notes', undefined, undefined, true), rightColumn),
    checkboxField(
      'City/Other Tax Payable Direct',
      contract?.city_other_tax__c,
      'Are there any City/State/Tourist taxes that are payable direct?',
      rightColumn,
    ),
    withLayout(
      field(
        'City/Other Tax Details',
        contract?.city_tax_comments__c ?? contract?.city_other_tax__c,
        'Amount payable, per person per night, in contracted currency.',
        true,
      ),
      rightColumn,
    ),
  ];
}
